<template>
  <v-container v-if="law">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa edit law-edit">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form_head">
               <h3 class="form_head-title">
                  {{ law.transName }}
               </h3>
            </div>
            <LawNormForm 
              v-if="normData"
              :options="normData"
              :law="law"
              @create="create"
              :error="error"
            />
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import LAW from '@/model/law'
import {Trans} from "@/plugins/Translation"
import LawNormForm from '@/components/law/LawNormForm.vue'

export default {
  name: 'LawEdit',
  components: {
    LawNormForm
  },
  data () {
    return {
      law: {},
      breadcrumbs: [],
      normData: null,
      error: {
        status: false,
        message: ''
      }
    }
  },
  
  mounted() {
    this.fetchData()
  },

  computed: {
    ...mapGetters({
      publicData: 'getSearchData'
    }),
  },

  methods: {
    ...mapMutations(['setLoading']),
     // генерация хлебных крошек
     generateBreadcrumbs(name) {
      this.breadcrumbs = [
        {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
        {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
        {text: name, disabled: false, href: Trans.currentLocaleUrl + '/law-view/' + this.$route.params.id},
        {text: this.$i18n.t('Добавление нормы'), disabled: true},
      ]
    },

    fetchData() {
        this.setLoading(true)
        LAW.getLaw(this.$route.params.id).then((response) => {
          this.law = response.data.law
          this.law.byLaws = response.data.byLaws
          this.generateBreadcrumbs(this.law.transName)
          this.setLoading(false)

          LAW.getNormData().then((response) => {
            this.normData = response.data
          }).catch((error) => {
      
          });
        }).catch((error) => {
          if(error.response.status != null) {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
          }
          this.setLoading(false)
        })
      },
      
      isError () {
        this.error.status = true
        this.error.message = 'Произошла ошибка. Пожалуйста, проверьте все поля и повторите попытку.'
        this.setLoading(false)
      },

      create(data) {
        console.log( data.form.norm.params.by_law_id.length == 0)
        if (data.form.norm.executionNorm == 1 && !data.isAddLegalAct && data.form.norm.params.by_law_id.length == 0) {
          this.error.status = true
          this.error.message = 'Выберите из существующих подзаконных актов или создайте новую'
        } else {
          this.error.status = false
          this.setLoading(true)
          if (!data.selectedExistingArticle && data.form.norm.params.article_value == 'Статья') {
            LAW.createLawArticle(data.form.article).then((response) => {
              this.isStatus204(response)
              data.form.norm.params.article_id = response.data.id
              this.createByLaw(data)
            }).catch((error) => {
              this.isError()
            })
          } else {
            this.createByLaw(data)
          }
        }
      },

      createByLaw(data) {
        if (data.isAddLegalAct) {
          LAW.createByLaw(data.legalAct).then((response) => {
            this.isStatus204(response)
            data.form.norm.params.by_law_id.push(response.data.id)
            LAW.createLawNorm(data.form.norm).then(() => {
              this.isStatus204(response)
              this.pushLawView(response)
            }).catch((error) => {
              this.isError()
            })
         
          }).catch((error) => {
            this.isError()
          })
        } else {
          LAW.createLawNorm(data.form.norm).then((response) => {
            this.isStatus204(response)
            this.pushLawView(response)
          }).catch((error) => {
            this.isError()
          })
        }
      },

      pushLawView (response) {
        this.$router.push({ name: 'law-view', params: { id: this.$route.params.id } })
      },

      isStatus204 (response) {
        if (response.status == 204) {
          this.isError()
          return
        }
      }
  }
}
</script>